export const STANDING_STEAM_ROOF_TYPES = ['Standing Seam Metal', 'Corrugated Metal', 'Metal Roofing'];
export const STANDING_STEAM = 'Standing Seam';
